import { auth, user } from "api";
import { getToken, setToken, removeToken } from "utils/auth";
import axios from "axios";
const state = {
  token: "",
  name: "",
  avatar: "",
  permissions: ""
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions;
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await auth.authorize(userInfo);
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + data.data.access_token;
        await setToken(data.data.access_token);
        resolve({ token: data.data.access_token });
      } catch (error) {
        reject(error.response.data);
      }
    });
  },
  // get user info
  setPermissions({ commit }, permissions) {
    commit("SET_PERMISSIONS", permissions);
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      user
        .logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");
          commit("SET_NAME", "");
          removeToken();
          resetRouter();
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");
      removeToken();
      resolve();
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
